import { login } from './login';
import { register } from './register';
import { logout } from './logout';
import { refreshAuthToken } from './refresh-token';
import { retrieveUserToken } from './retrieveUserToken';

export const IdentityAPI = {
    login,
    logout,
    register,
    refreshAuthToken,
    retrieveUserToken,
};

export * from './types';
